export default {"src":"/_next/static/media/add-icon.65a0c863.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};